import Keyset from "@frog/source/utility/Keyset.js"
import stages from "@frog/source/data/stages.js"

import {parseEncounter} from "@frog/source/utility/Parser.js"

let encounters = [
    Keyset.merge(parseEncounter(require("@frog/source/data/encounters/apple.csv")), {
        "slug": "level1",
        "audio": "Music:Normal",
        "images": {
            "background": require("@frog/source/images/ld47/Level 1 Background.png").default,
            "building": require("@frog/source/images/ld47/Level 1 building.png").default,
            "exits": [
                require("@frog/source/images/ld47/Level 1 Exit tile1.png"),
                require("@frog/source/images/ld47/Level 1 Exit tile2.png"),
                require("@frog/source/images/ld47/Level 1 Exit tile3.png"),
                require("@frog/source/images/ld47/Level 1 Exit tile4.png"),
            ]
        },
        "nextEncounterSlug": "level2",
    }),
    Keyset.merge(parseEncounter(require("@frog/source/data/encounters/banana.csv")), {
        "slug": "level2",
        "audio": "Music:Normal", // TEMP
        "images": {
            "background": require("@frog/source/images/ld47/Level 2 Background.png").default,
            "building": require("@frog/source/images/ld47/Level 2 building.png").default,
            "exits": [
                require("@frog/source/images/ld47/Level 2 Exit tile1.png"),
                require("@frog/source/images/ld47/Level 2 Exit tile2.png"),
                require("@frog/source/images/ld47/Level 2 Exit tile3.png"),
                require("@frog/source/images/ld47/Level 2 Exit tile4.png"),
            ],
            "foregroundfences": require("@frog/source/images/ld47/Level 2 Fence.png"),
            // "fences": [
            //     {"position": {"x": 2, "y": 5, "z": 1}, "direction": "left"},
            //     {"position": {"x": 5, "y": 4, "z": 1}, "direction": "right"},
            // ],
        },
        "nextEncounterSlug": "level3",
    }),
    Keyset.merge(parseEncounter(require("@frog/source/data/encounters/cherry.csv")), {
        "slug": "level3",
        "images": {
            "background": require("@frog/source/images/ld47/Level 3 Background.png").default,
            "building": require("@frog/source/images/ld47/Level 3 Building.png").default,
            "exits": [
                require("@frog/source/images/ld47/Level 3 Exit tile1.png"),
                require("@frog/source/images/ld47/Level 3 Exit tile2.png"),
                require("@frog/source/images/ld47/Level 3 Exit tile3.png"),
                require("@frog/source/images/ld47/Level 3 Exit tile4.png"),
            ],
            "backgroundfences": require("@frog/source/images/ld47/Level 3 Fence - background.png"),
            "foregroundfences": require("@frog/source/images/ld47/Level 3 Fence.png"),
            // "fences": [
            //     {"position": {"x": 5, "y": 1, "z": 1}, "direction": "right"},
            //     {"position": {"x": 5, "y": 5, "z": 1}, "direction": "right"},
            //     {"position": {"x": -1, "y": 1, "z": 1}, "direction": "right"},
            //     {"position": {"x": -1, "y": 5, "z": 1}, "direction": "right"},
            // ],
        },
        "nextEncounterSlug": "level4",
    }),
    Keyset.merge(parseEncounter(require("@frog/source/data/encounters/strawberry.csv")), {
        "slug": "level4",
        "images": {
            "background": require("@frog/source/images/ld47/Level 4 Background.png").default,
            "building": require("@frog/source/images/ld47/Level 4 Building.png").default,
            "exits": [
                require("@frog/source/images/ld47/Level 4 Exit tile SW1.png"),
                require("@frog/source/images/ld47/Level 4 Exit tile SW2.png"),
                require("@frog/source/images/ld47/Level 4 Exit tile SW3.png"),
                require("@frog/source/images/ld47/Level 4 Exit tile SW4.png"),
            ],
            // "fences": [
            //     {"position": {"x": 4, "y": 5, "z": 1}, "direction": "left"},
            //     {"position": {"x": 1.7, "y": -1.5, "z": 1}, "direction": "left"},
            // ],
        },
        "nextEncounterSlug": "level5",
    }),
    Keyset.merge(parseEncounter(require("@frog/source/data/encounters/blueberry.csv")), {
        "slug": "level5",
        "audio": "Music:Final",
        "images": {
            "background": require("@frog/source/images/ld47/Level 5 Background.png").default,
            "building": require("@frog/source/images/ld47/Level 5 building.png").default,
            "exits": [
                require("@frog/source/images/ld47/Level 5 Exit tile NE1.png"),
                require("@frog/source/images/ld47/Level 5 Exit tile NE2.png"),
                require("@frog/source/images/ld47/Level 5 Exit tile NE3.png"),
                require("@frog/source/images/ld47/Level 5 Exit tile NE4.png"),
            ],
            "backgroundfences": require("@frog/source/images/ld47/Level 5 Fence - background.png"),
            "foregroundfences": require("@frog/source/images/ld47/Level 5 Fence.png"),
            // "fences": [
            //     {"position": {"x": 3, "y": 5, "z": 1}, "direction": "left"},
            //     {"position": {"x": 1, "y": -1.25, "z": 1}, "direction": "left"},
            //     {"position": {"x": 5, "y": -1.25, "z": 1}, "direction": "left"},
            // ],
        },
        "nextEncounterSlug": "credits",
    }),
    // {
    //     "slug": "august-24-2020",
    //     "type": "combat",
    //     "stage": {"reference": "around"},
    //     "label": "August 24th",
    // },
    // {
    //     "slug": "august-25-2020",
    //     "type": "combat",
    //     "stage": {"reference": "boxed-in"},
    //     // "phases": ["prepare", "battle"]
    //     // "victory": "survive",
    //     // "music": "heroic",
    //     "label": "August 25th",
    // },
    // // {
    // //     "slug": "august-26-2020",
    // //     "type": "combat",
    // //     "stage": {"reference": "august-26-2020"},
    // //     "label": "August 26th",
    // // },
    // parseEncounter("august-26-2020", require("@frog/source/data/encounters/august-26-2020.csv")),
    // parseEncounter("august-27-2020", require("@frog/source/data/encounters/august-27-2020.csv")),
    // parseEncounter("august-28-2020", require("@frog/source/data/encounters/august-28-2020.csv")),
    // parseEncounter("august-29-2020", require("@frog/source/data/encounters/august-29-2020.csv")),
    // parseEncounter("september-2-2020", require("@frog/source/data/encounters/september-2-2020.csv")),
    // parseEncounter("september-8-2020", require("@frog/source/data/encounters/september-8-2020.csv")),
    // parseEncounter("september-9-2020", require("@frog/source/data/encounters/september-9-2020.csv")),
    // parseEncounter("september-10-2020", require("@frog/source/data/encounters/september-10-2020.csv")),
    // parseEncounter("september-12-2020", require("@frog/source/data/encounters/september-12-2020.csv")),
    // {
    //     "slug": "sandbox",
    //     "type": "combat",
    //     "stage": {
    //         "slug": "sandbox",
    //         "units": [
    //             {"family": "bulbasaur", "level": 3, "affiliation": "good", "maxhealth": 3, "moverange": 0, "skills": ["charge"], "position": {"x": 3, "y": 0, "z": 1}},
    //             // {"family": "bulbasaur", "level": 1, "affiliation": "bad", "maxhealth": 4, "skills": ["strike mid-range"], "position": {"x": 3, "y": 5, "z": 1}},
    //             // {"family": "bulbasaur", "level": 1, "affiliation": "bad", "maxhealth": 4, "skills": ["strike mid-range"], "position": {"x": 0, "y": 4, "z": 1}},
    //             // {"family": "charmander", "level": 1, "affiliation": "bad", "skills": ["strike mid-range"], "moverange": 2, "position": {"x": 1, "y": 3, "z": 1}, "health": 2},
    //             {"family": "squirtle", "level": 3, "affiliation": "good", "maxhealth": 3, "skills": ["readytrap"], "position": {"x": 3, "y": 3, "z": 1}},
    //             // {"family": "charmander", "level": 1, "affiliation": "good", "skills": ["leap", "counterattack"], "position": {"x": 2, "y": 4, "z": 1}},
    //         ],
    //         "world": {
    //             "reference": "flat",
    //         }
    //     },
    //     "label": "Sandbox",
    // },
    // parseEncounter("september-15-2020", require("@frog/source/data/encounters/september-15-2020.csv")),
    // parseEncounter("september-16-2020", require("@frog/source/data/encounters/september-16-2020.csv")),
    // parseEncounter("september-17-2020", require("@frog/source/data/encounters/september-17-2020.csv")),
    // parseEncounter("september-17-2020-2", require("@frog/source/data/encounters/september-17-2020-2.csv")),
    // parseEncounter("september-18-2020-2", require("@frog/source/data/encounters/september-18-2020-2.csv")),
    // parseEncounter("september-18-2020-3", require("@frog/source/data/encounters/september-18-2020-3.csv")),
    // parseEncounter("september-23-2020", require("@frog/source/data/encounters/september-23-2020.csv")),
]

encounters = Keyset.convert(encounters, "slug")
encounters = Keyset.map(encounters, (encounter) => {
    if(encounter.nextEncounterSlug != undefined) { // TODO: actually define this in the encounter.stage, not the encounter
        encounter.stage.events = encounter.stage.events || {}
        encounter.stage.events["success"] = [
            {
                "type": "load encounter",
                "isPreservingState": true,
                "encounterSlug": encounter.nextEncounterSlug,
            },
        ]
        encounter.stage.events["failure"] = [
            {
                "type": "load encounter",
                "isPreservingState": false,
                "encounterSlug": encounter.slug,
            }
        ]
        // if(encounter.nextEncounterSlug == "level4") { // TODO: what the fuck is this hardcoding overloading??
        //     encounter.stage.events["success"][0].duration = 4
        // }
        if(encounter.nextEncounterSlug == "credits") { // TODO: what the fuck is this hardcoding overloading??
            encounter.stage.events["success"] = [
                {
                    "type": "navigate",
                    "path": "/credits"
                },
            ]
        }
    }
    if(encounter.stage.reference != undefined) {
        if(stages[encounter.stage.reference] == undefined) {
            throw "Could not find stage " + encounter.stage.reference
        }
        encounter.stage = stages[encounter.stage.reference]
        // encounter.stage = Keyset.merge(referencedStage, encounter.stage)
        // TODO: Since this is a shallow merge, this isn't accomplishing anything.
        // TODO: there are now three formats, one is the text-friendly atomic file,
        // format, one is the in-data referenced format but not fully playable, and
        // the last is the in class fully playable. Maybe the interim one in-data
        // shouldn't exist and should remain lightweight and jsut be JIT'd when
        // instantiating everything else for the encounter? (which will have
        // it's own set of overrides)
    }
    return encounter
})

export default encounters
